(function() {
  let scrollPosition = 0;

  function initializePjax() {
    if (typeof Pjax === 'undefined' || window.myThemePjaxInstance) { return; }
    
    const productSection = document.querySelector('.product-section');
    if (!productSection) return;
    
    const sectionId = productSection.id.replace('shopify-section-', '');

    try {
      const pjax = new Pjax({
        elements: "a[data-pjax-link]",
        selectors: ['title', `#ProductInfo-${sectionId}`, `#MediaGallery-${sectionId}`],
        cacheBust: false,
        timeout: 5000,
        scrollTo: false
      });
      window.myThemePjaxInstance = pjax;

      document.addEventListener('pjax:send', () => {
        scrollPosition = window.pageYOffset;
        const productGrid = document.querySelector('.product-grid-container');
        if (productGrid) productGrid.classList.add('is-loading');
      });

      document.addEventListener('pjax:complete', () => {
        window.scrollTo({ top: scrollPosition, behavior: 'instant' });
        const productGrid = document.querySelector('.product-grid-container');
        if (productGrid) productGrid.classList.remove('is-loading');
        
        // 只重新初始化 BundleSelector，不再重新初始化 PJAX
        initializeBundleSelectors();
      });
    } catch (e) { console.error("PJAX Initialization Failed:", e); }
  }

  class BundleSelector {
    constructor(container) {
      this.container = container;
      this.radioButtons = this.container.querySelectorAll('.package-selector__radio-input');
      this.sectionId = this.container.dataset.sectionId;
      this.mainProductForm = document.getElementById(`product-form-${this.sectionId}`);
      this.variantSelectsComponent = document.querySelector(`variant-selects[data-section="${this.sectionId}"]`);
      this.attachEvents();
      this.updateIncludesVisibility();
    }

    attachEvents() {
      this.radioButtons.forEach(radio => {
        radio.addEventListener('change', (event) => {
          this.updateIncludesVisibility();
          this.updateMainForm(event.target.value);
        });
      });
    }

    updateMainForm(variantId) {
      if (this.mainProductForm) {
        const input = this.mainProductForm.querySelector('input[name="id"]');
        if (input) {
          input.value = variantId;
        }
      }
      
      if (this.variantSelectsComponent && typeof this.variantSelectsComponent.renderProductInfo === 'function') {
        const variant = this.variantSelectsComponent.getVariantData().find(v => v.id == variantId);
        if (variant) {
          this.variantSelectsComponent.currentVariant = variant;
          this.variantSelectsComponent.renderProductInfo();
        }
      }
    }

    updateIncludesVisibility() {
      const allGroups = this.container.querySelectorAll('.package-selector__variant-group');
      allGroups.forEach(group => {
        const radio = group.querySelector('.package-selector__radio-input');
        const includesContainer = group.querySelector('.package-includes-container');
        const includesContent = includesContainer ? includesContainer.querySelector('.package-includes__content') : null;
        if (radio && radio.checked && includesContent && includesContainer.innerText.trim() !== '') {
          includesContainer.style.display = 'block';
        } else if (includesContainer) {
          includesContainer.style.display = 'none';
        }
      });
    }
  }

  function initializeBundleSelectors() {
    const containers = document.querySelectorAll('.package-selector-container');
    containers.forEach(container => {
      const section = container.closest('.shopify-section');
      if (section) {
        container.dataset.sectionId = section.id.replace('shopify-section-', '');
      }
      // 移除旧的实例标记，允许重新初始化
      container.removeAttribute('data-bundle-initialized');
      new BundleSelector(container);
      container.setAttribute('data-bundle-initialized', 'true');
    });
  }

  function runInitialSetup() {
    initializePjax();
    initializeBundleSelectors();
  }

  document.addEventListener('DOMContentLoaded', runInitialSetup);
})();